import { Modal, Space } from '@billy/design-system'
import { ReactElement } from 'react'

import { EmailMessage } from './elements/EmailMessage'
import { EmailRecipients } from './elements/EmailRecipients'
import { EmailSubject } from './elements/EmailSubject'

export const RecurringInvoiceEmailTemplateModalBody = (): ReactElement => {
  return (
    <Modal.Body>
      <EmailRecipients />
      <Space size="s16" />
      <EmailSubject />
      <Space size="s16" />
      <EmailMessage />
    </Modal.Body>
  )
}
